import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { PDSService } from '../../../services/pds.service';
@Component({
  selector: 'app-family-travel-insurance',
  standalone: true,
  imports: [FooterComponent, StaticSearchComponent, CommonHeaderComponent],
  templateUrl: './family-travel-insurance.component.html',
  styleUrl: './family-travel-insurance.component.scss',
})
export class FamilyTravelInsuranceComponent {
  partnerCode: string = '';
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public pdsService: PDSService,
  ) {
    this.titleService.setTitle(
      'Holiday Travel Insurance for Families | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content:
        'World2Cover makes family travel insurance easy! Compare our levels of cover and select the best family travel insurance for you. Get your quote today!',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Holiday Travel Insurance for Families | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'World2Cover makes family travel insurance easy! Compare our levels of cover and select the best family travel insurance for you. Get your quote today!',
    });
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }
}
